<template>
  <row-action
    icon="TrashIcon"
    :label="label || $t('foundation.rowDelete')"
    :danger="true"
  />
</template>

<script>
import RowAction from '@/components/foundation/RowAction.vue'

export default {
  name: 'DeleteRow',
  components: { RowAction },
  props: { label: { type: String, default: '' } },
}
</script>
